const formatDate = (dateString) => {
    if(dateString.indexOf("T") === -1) {
        dateString = `${dateString}T00:00:00`;
    }
    
    let dt = new Date(dateString);
    return dt;
} 

export const DatetimeFormatUtil = (date,config) => {
    let dt = formatDate(date);
    if(typeof config === "undefined") {
        config = {};
    }

    let defaultConfig = {
        timezone: "America/Sao_Paulo"
    };
    // verificar se virá uma data UTC
    return dt.toLocaleString("pt-BR",{...defaultConfig, ...config});
}

const DateFormatUtil = (date, config) => {
    let dt = formatDate(date);
    if(typeof config === "undefined") {
        config = {};
    }

    let defaultConfig = {
        day: "2-digit", 
        month: "2-digit",
        year: "numeric",
        timezone: "America/Sao_Paulo"
    };
    // verificar se virá uma data UTC
    return dt.toLocaleString("pt-BR",{...defaultConfig, ...config});
}

export default DateFormatUtil;